export default "__VITE_ASSET__DHHs8Wkb__"